import { Directive, Input, ElementRef } from '@angular/core';

import { DBService } from '../db.service';

@Directive({
  selector: '[username]'
})
export class UsernameDirective {
  @Input() username: string;

  private firstName = "";
  private lastName = "";


  constructor(
    private el: ElementRef,
    private dbService: DBService
  ) { }

  ngOnInit() {
    this.showUsername();
  }

  ngOnChanges() {
    this.showUsername();
  }

  showUsername() {
    if (this.username) {
      this.dbService.getMember(this.username).subscribe(user => {
        if (user.firstName && user.lastName) {
          this.el.nativeElement.innerHTML = `${user.firstName} ${user.lastName}`;
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/username.directive.ts